/**
 * Flush timing + auto-retry policy for the event outbox.
 * After max auto attempts, the row is held for the Sync now button.
 */

/** Abort a hung Arena call so the spinner cannot spin forever. */
export const FLUSH_HTTP_MS = 5000;

/** Row left in "flushing" longer than this is treated as a failed attempt. */
export const FLUSH_STUCK_MS = 7000;

/** Automatic flush tries before holding for manual Sync now. */
export const MAX_AUTO_ATTEMPTS = 3;

export interface FlushAttemptResult {
    attempts: number;
    /** True once attempts hit MAX_AUTO_ATTEMPTS - stop auto-poll, wait for Sync now. */
    holdForManual: boolean;
}

/** Bump attempt count after a timed-out / failed flush. */
export const bumpFlushAttempt = (attempts: number | undefined): FlushAttemptResult => {
    const next = (attempts ?? 0) + 1;
    return { attempts: next, holdForManual: next >= MAX_AUTO_ATTEMPTS };
};
